import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const MenuPortal = ({ anchorRef, menuRef, width = 184, children }) => {
	const [style, setStyle] = useState(null);

	useLayoutEffect(() => {
		const place = () => {
			const anchor = anchorRef.current;
			if (!anchor) return;
			const rect = anchor.getBoundingClientRect();
			const left = Math.min(
				Math.max(8, rect.right - width),
				window.innerWidth - width - 8
			);
			const estimatedHeight = 240;
			let top = rect.bottom + 4;
			if (top + estimatedHeight > window.innerHeight - 8) {
				top = Math.max(8, rect.top - estimatedHeight - 4);
			}
			setStyle({
				position: 'fixed',
				top,
				left,
				width,
				zIndex: 40,
			});
		};
		place();
		window.addEventListener('resize', place);
		window.addEventListener('scroll', place, true);
		return () => {
			window.removeEventListener('resize', place);
			window.removeEventListener('scroll', place, true);
		};
	}, [anchorRef, width]);

	if (!style || typeof document === 'undefined') return null;

	return createPortal(
		<div
			ref={menuRef}
			className="board-float-menu"
			style={style}
			role="menu"
			onMouseDown={(event) => event.stopPropagation()}
			onClick={(event) => event.stopPropagation()}
		>
			{children}
		</div>,
		document.body
	);
};

export default MenuPortal;
